import { ltiParams } from 'up';
import { LtiActionsUnion, LtiActions } from '../actions/ltiparams.action';
import { ModulesActions, ModulesActionsUnion } from '../actions/module.action';
import {
  LtiParamsState,
  initialLtiParamsState,
} from '../state/ltiparams.state';
import { ModuleState, initialModuleState } from '../state/module.state';

export const ltiReducer = (
  state = initialLtiParamsState,
  action: LtiActionsUnion
): LtiParamsState => {
  switch (action.type) {
    case LtiActions.SetLtiParams: {
      return {
        ...state,
        ltiParams: action.payload.ltiParams,
      };
    }
    case LtiActions.AddModuleTitle: {
      let updatedLtiParams = { ...state.ltiParams };
      updatedLtiParams['moduleTitle'] = action.payload;

      return {
        ...state,
        ltiParams: updatedLtiParams,
      };
    }
    default:
      return state;
  }
};
